/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared';

export type TCreateHomeownerMessageFromOfferModel = IModel<
  ICreateHomeownerMessageFromOfferRequest,
  TCreateHomeownerMessageFromOfferResponse
>;

export interface ICreateHomeownerMessageFromOfferRequest {
  /** Код подтверждения телефона **/
  confirmationCode?: string | null;
  /** ID объявления (realty) **/
  offerId?: number | null;
  /** Источник заявки **/
  source?: string | null;
}

export type TCreateHomeownerMessageFromOfferResponse =
  | ICreateHomeownerMessageFromOfferResponse200
  | ICreateHomeownerMessageFromOfferResponse400;

export interface ICreateHomeownerMessageFromOfferResponse200
  extends IModelResponse<ICreateHomeownerMessageFromOfferResponse> {
  statusCode: 200;
}

export interface ICreateHomeownerMessageFromOfferResponse400
  extends IModelResponse<ICreateHomeownerMessageFromOfferResponseError> {
  statusCode: 400;
}

export interface ICreateHomeownerMessageFromOfferResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateHomeownerMessageFromOfferResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateHomeownerMessageFromOfferResponse | ICreateHomeownerMessageFromOfferResponseError;

export enum EStatus {
  /** Не правильный код подтверждения **/
  CodeError = 'codeError',
  /** Дубликат **/
  Duplicate = 'duplicate',
  /** Необходимо подтверждение номера телефона **/
  NeedPhoneConfirm = 'needPhoneConfirm',
  /** Успешно **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateHomeownerMessageFromOfferResponse): TResponse200;
  400(response: ICreateHomeownerMessageFromOfferResponseError): TResponse400;
}
